import React from 'react'
import { paidLog } from '../../pages/types';
import { ISOStringToDateFormat, numberWithCommas, ISOStringToDateFormatStbDate, cardFormat } from '../../lib/utils'

function PaymentHistoryItems(v:paidLog){
  return(
    <div className="stb_subscriber_history_item">
      {v.failedMessage?
        <span className='stb_subscriber_history_item_result error'>결제 실패</span>
        :
        <span className='stb_subscriber_history_item_result'>{numberWithCommas(v.totalCharge)}원</span>
      }
      <p className="stb_subscriber_history_item_date">{ISOStringToDateFormat(v.createdDate)}</p>
      <p className="stb_subscriber_history_item_info">유료 구독({ISOStringToDateFormatStbDate(v.startDate)} ~ {ISOStringToDateFormatStbDate(v.endDate)})</p>
      <p className="stb_subscriber_history_item_card">
        {cardFormat(v.paymentOption)}
        {!v.failedMessage &&
          <a href={v.receiptUrl} rel="noopener noreferrer" target="_blank">영수증 보기</a> 
        }
      </p>
      <p className="stb_subscriber_history_item_error">
        {v.failedMessage?v.failedMessage:''}
      </p>
  </div>
  )
}

export default PaymentHistoryItems